---
title: Conversations and feedback
summary: Find and manage your past conversations, and rate the answers you get.
visibility: authenticated
audience: end-user
section: Using an expert
order: 116
last_verified: 2026-10-07
owner: docs
---

# Conversations and feedback

## Your conversation history

Your past conversations are on the **Chat** page: choose **Chat** in the sidebar. On a wide
screen the list sits beside the conversation; on a narrower one, open it with the
**Conversations** button at the top of the page. Click any one to reopen it and pick up where
you left off — its messages come back with it.

- **Start a new conversation** with the **New conversation** button at the top of the list,
  then choose which expert to talk to.
- **Rename** a conversation with the pencil icon that appears when you hover over it (press
  Enter to confirm, Escape to cancel).
- **Delete** a conversation with the trash icon. Deletion is immediate — there's no
  confirmation step, so delete with care.

## Rate an answer

Hover over any reply to reveal a thumbs-up and thumbs-down. Click one to rate that answer —
**Good response** or **Poor response**. Your rating is recorded right away and helps improve
the expert over time.

## Next

- [Chat with an expert](/help/enduser/chat-with-an-expert) — the basics of a conversation.
